import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { BASE_URL } from '../../lib/env';
// import { useState, useEffect, useRef } from 'react';
/* ── Responsive hook ── */
function useBreakpoint() {
  const [bp, setBp] = useState(() => {
    if (typeof window === 'undefined') return 'desktop';
    const w = window.innerWidth;
    if (w < 480) return 'xs';
    if (w < 768) return 'sm';
    if (w < 1024) return 'md';
    return 'desktop';
  });
  useEffect(() => {
    const handler = () => {
      const w = window.innerWidth;
      if (w < 480) setBp('xs');
      else if (w < 768) setBp('sm');
      else if (w < 1024) setBp('md');
      else setBp('desktop');
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return bp;
}

const BRANDS = ['Louis Vuitton','Chanel','Gucci','Hermès','Prada','Dior','Balenciaga','Saint Laurent','Bottega Veneta','Celine','Fendi','Burberry','Valentino','Givenchy','Loewe','Bvlgari'];

export function BrandMarquee() {
  const doubled = [...BRANDS,...BRANDS];
  return (
    <section style={{ background:'var(--dark)', padding:'22px 0', overflow:'hidden', borderTop:'1px solid rgba(255,255,255,0.04)' }}>
      <div className="animate-marquee" style={{ display:'flex', whiteSpace:'nowrap' }}>
        {doubled.map((b,i) => (
          <span key={i} style={{ display:'inline-flex', alignItems:'center', gap:20, padding:'0 20px' }}>
            <span style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:300, color:'rgba(255,255,255,0.28)', letterSpacing:'0.18em', textTransform:'uppercase' }}>{b}</span>
            <span style={{ color:'rgba(201,168,76,0.35)', fontSize:16 }}>✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}

function useCountUp(target, shouldStart, duration = 1800) {
  const [count, setCount] = useState(0);
  const rafRef = useRef(null);
 
  useEffect(() => {
    if (!shouldStart) return;
    const startTime = performance.now();
 
    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease-out cubic so it decelerates near the final number
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setCount(target);
      }
    };
 
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [shouldStart, target, duration]);
 
  return count;
}
 
// ── Special sub-component for "48hr" ──
function AnimatedDelivery({ active }) {
  const n = useCountUp(48, active, 1500);
  return <>{n}hr</>;
}
 
// ── Replace your existing StatsBar export with this ──
export function StatsBar() {
  const bp = useBreakpoint();
  const isMobile = bp === 'xs' || bp === 'sm';
 
  // Fire animation once when section scrolls into view
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
 
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // only animate once
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
 
  const pieces       = useCountUp(500, visible, 1600);
  const authenticity = useCountUp(100, visible, 1400);
  const houses       = useCountUp(12,  visible, 1200);
 
  const statFontSize = isMobile ? 'clamp(32px,8vw,48px)' : 'clamp(40px,5vw,56px)';
 
  const statStyle = {
    fontFamily: 'var(--font-display)',
    fontSize: statFontSize,
    fontWeight: 300,
    color: 'var(--dark)',
    lineHeight: 1,
  };
 
  const labelStyle = {
    fontSize: 9,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    color: 'var(--grey-mid)',
    fontWeight: 600,
    fontFamily: 'var(--font-body)',
    marginTop: 6,
  };
 
  return (
    <section
      ref={sectionRef}
      style={{
        background: 'var(--cream)',
        padding: isMobile ? '40px 16px' : '60px 40px',
        borderTop: '1px solid #ede9e3',
      }}
    >
      <div style={{
        maxWidth: 900,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 0,
      }}>
        {/* ── Left column ── */}
        <div style={{
          display: 'flex', flexDirection: 'column',
          gap: isMobile ? 24 : 32,
          alignItems: 'center',
          padding: isMobile ? '12px 0' : '20px 0',
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={statStyle}>{pieces}+</div>
            <div style={labelStyle}>Pieces Curated</div>
          </div>
 
          <div style={{ textAlign: 'center' }}>
            <div style={statStyle}>
              {visible ? <AnimatedDelivery active={visible} /> : '0hr'}
            </div>
            <div style={labelStyle}>Average Delivery</div>
          </div>
        </div>
 
        {/* ── Right column ── */}
        <div style={{
          display: 'flex', flexDirection: 'column',
          gap: isMobile ? 24 : 32,
          alignItems: 'center',
          padding: isMobile ? '12px 0' : '20px 0',
          borderLeft: '1px solid #ede9e3',
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={statStyle}>{authenticity}%</div>
            <div style={labelStyle}>Authenticity Rate</div>
          </div>
 
          <div style={{ textAlign: 'center' }}>
            <div style={statStyle}>{houses}+</div>
            <div style={labelStyle}>Global Houses</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Testimonials() {
  const [reviews, setReviews] = useState([]);
  const [idx, setIdx]         = useState(0);
  const [paused, setPaused]   = useState(false);
  const bp = useBreakpoint();

  const isMobile = bp === 'xs' || bp === 'sm';
  const isTablet = bp === 'md';

  // How many cards to show
  const visibleCount = isMobile ? 1 : isTablet ? 2 : 3;

  useEffect(() => {
    // fetch('http://localhost/CODIZN-full-project%20(2)/codizn/backend/index.php?route=testimonials')
    fetch(`${BASE_URL}/index.php?route=testimonials`)
      .then(r => r.json())
      .then(d => setReviews(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (reviews.length <= visibleCount || paused) return;
    const t = setInterval(() => {
      setIdx(i => (i + 1) % reviews.length);
    }, 4500);
    return () => clearInterval(t);
  }, [reviews.length, paused, visibleCount]);

  if (reviews.length === 0) return null;

  const visible = Array.from({ length: visibleCount }, (_, offset) =>
    reviews[(idx + offset) % reviews.length]
  );

  const gridCols = isMobile ? '1fr' : isTablet ? 'repeat(2,1fr)' : 'repeat(3,1fr)';

  return (
    <section
      style={{ background:'var(--cream)', padding: isMobile ? '48px 16px' : '80px 50px' }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div style={{ maxWidth:'100%', margin:'0 auto' }}>

        {/* Header */}
        <div style={{ textAlign:'center', marginBottom: isMobile ? 32 : 52 }}>
          <div style={{ fontSize:10, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:600, marginBottom:16, fontFamily:'var(--font-body)' }}>
            Client Stories
          </div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,48px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em', margin:0 }}>
            What Our Clients Say
          </h2>
        </div>

        {/* Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: gridCols,
          gap: isMobile ? 12 : 2,
          padding: isMobile ? '0' : '0',
        }}>
          {visible.map((r, i) => (
            <div key={`${r.id}-${i}`} style={{
              background:'#fff', padding: isMobile ? '28px 20px 30px' : '36px 32px 38px',
              display:'flex', flexDirection:'column', gap:18,
              border:'1px solid #ede9e3',
              transition:'opacity 0.5s',
            }}>
              {/* Stars */}
              <div style={{ display:'flex', gap:4 }}>
                {Array.from({ length: Number(r.stars)||5 }).map((_, si) => (
                  <svg key={si} width={13} height={13} viewBox="0 0 24 24" fill="var(--gold)">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <p style={{
                fontSize: isMobile ? 16 : 18, color:'var(--grey-dark)', lineHeight:1.85,
                fontStyle:'italic', fontFamily:'var(--font-display)',
                fontWeight:300, margin:0, flexGrow:1,
              }}>
                "{r.text}"
              </p>

              {/* Reviewer */}
              <div style={{ paddingTop:16, borderTop:'1px solid #ede9e3' }}>
                <div style={{
                  fontSize:10, letterSpacing:'0.18em', textTransform:'uppercase',
                  color:'var(--dark)', fontWeight:600, fontFamily:'var(--font-body)',
                }}>
                  {r.name}{r.location ? ` — ${r.location}` : ''}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dot navigation */}
        {reviews.length > visibleCount && (
          <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:32 }}>
            {reviews.map((_, i) => (
              <button key={i} onClick={() => setIdx(i)}
                style={{
                  width: i===idx ? 28 : 8, height:8,
                  borderRadius:4, border:'none', cursor:'pointer',
                  background: i===idx ? 'var(--gold)' : 'rgba(0,0,0,0.15)',
                  transition:'all 0.3s', padding:0,
                }} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export function RequestCTA({ onOpen }) {
  const bp = useBreakpoint();   // ✅ call once
  const isMobile = bp === 'xs' || bp === 'sm';

  return (
    <section style={{ background:'var(--dark)', padding: isMobile ? '60px 16px' : '80px 24px', textAlign:'center' }}>
      <div style={{ maxWidth:560, margin:'0 auto', display:'flex', flexDirection:'column', alignItems:'center', gap:18 }}>
        <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500 }}>Sourcing Service</div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(26px,5vw,46px)', fontWeight:300, color:'#fff', letterSpacing:'-0.01em', lineHeight:1.15 }}>
          Can't Find Your Piece?
        </h2>
        <p style={{ fontSize:13, color:'rgba(255,255,255,0.5)', fontWeight:300, lineHeight:1.75, maxWidth:360 }}>
          Tell us the brand, model and colour. Our team sources globally and delivers to your door.
        </p>
        <button
          onClick={onOpen}
          style={{
            marginTop:14,
            padding: isMobile ? '14px 32px' : '14px 40px',
            background:'var(--gold)',
            color:'var(--dark)',
            fontSize:11,
            letterSpacing:'0.22em',
            textTransform:'uppercase',
            fontWeight:700,
            border:'none',
            cursor:'pointer',
            transition:'background 0.25s',
            width: isMobile ? '100%' : 'auto',
          }}
          onMouseEnter={e=>e.target.style.background='var(--gold-dark)'}
          onMouseLeave={e=>e.target.style.background='var(--gold)'}
        >
          Request a Piece →
        </button>
      </div>
    </section>
  );
}

export function FeaturedBrands() {
  const brands = ['Louis Vuitton','Chanel','Gucci','Hermès','Prada','Dior'];
  const isMobile = ['xs','sm'].includes(useBreakpoint());
  return (
    <section style={{ padding: isMobile ? '48px 16px' : '72px 40px', background:'#fff' }}>
      <div style={{ maxWidth:1200, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom: isMobile ? 32 : 48 }}>
          <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500, marginBottom:14 }}>Curated Selection</div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(26px,4vw,44px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em' }}>Shop by Designer</h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fill,minmax(160px,1fr))', gap:16 }}>
          {brands.map(b => (
            <Link key={b} to={`/shop?brand=${encodeURIComponent(b)}`}
              style={{ padding:'28px 16px', border:'1px solid var(--grey)', textAlign:'center', textDecoration:'none', transition:'all 0.25s', display:'block' }}
              onMouseEnter={e=>{ e.currentTarget.style.borderColor='var(--gold)'; e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,0.06)'; }}
              onMouseLeave={e=>{ e.currentTarget.style.borderColor='var(--grey)'; e.currentTarget.style.boxShadow='none'; }}>
              <span style={{ fontFamily:'var(--font-display)', fontSize: isMobile ? 15 : 18, fontWeight:300, color:'var(--dark)', letterSpacing:'0.05em' }}>{b}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TrustBar() {
  const bp = useBreakpoint();
  const isMobile = bp === 'xs' || bp === 'sm';

  const items = [
    {
      label: 'Authenticity Guaranteed',
      desc: 'Accompanied by original boutique bills.',
      icon: (
        <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <polyline points="9,12 11,14 15,10"/>
        </svg>
      ),
    },
    {
      label: 'Globally Sourced',
      desc: 'Directly from Paris, Milan & London.',
      icon: (
        <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      ),
    },
    {
      label: 'Bespoke Packaging',
      desc: 'Arrives in signature designer boxes.',
      icon: (
        <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
          <polyline points="3.27,6.96 12,12.01 20.73,6.96"/>
          <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
      ),
    },
    {
      label: 'Best Value Assured',
      desc: 'Expertly priced to reflect true luxury market value.',
      icon: (
        <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
          <path d="M12 1v22"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
    },
  ];

  return (
    <section style={{
      background: 'var(--cream)',
      padding: isMobile ? '32px 16px' : '48px 40px',
      borderTop: '1px solid #ede9e3',
      borderBottom: '1px solid #ede9e3',
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        gap: isMobile ? 16 : 8,
      }}>
        {items.map((item) => (
          <div key={item.label} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-start',
            textAlign: isMobile ? 'center' : 'left',
            padding: isMobile ? '20px 10px' : '28px 40px',
          }}>
            <div style={{ color: 'var(--dark)', marginBottom: 14, opacity: 0.55 }}>
              {item.icon}
            </div>
            <div style={{
              fontSize: isMobile ? 11 : 12,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              fontWeight: 500,
              color: 'var(--dark)',
              marginBottom: 6,
            }}>
              {item.label}
            </div>
            <div style={{
              fontSize: 11,
              color: 'var(--grey-mid)',
              lineHeight: 1.6,
              maxWidth: 220,
            }}>
              {item.desc}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}


// import { Link } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import { BASE_URL } from '../../lib/env';

// /* ─────────────────────────────────────────────
//    Shared hook
// ───────────────────────────────────────────── */
// function useBreakpoint() {
//   const get = () => {
//     if (typeof window === 'undefined') return 'desktop';
//     const w = window.innerWidth;
//     if (w < 480) return 'xs';
//     if (w < 768) return 'sm';
//     if (w < 1024) return 'md';
//     return 'desktop';
//   };
//   const [bp, setBp] = useState('desktop');
//   useEffect(() => {
//     setBp(get());
//     const h = () => setBp(get());
//     window.addEventListener('resize', h);
//     return () => window.removeEventListener('resize', h);
//   }, []);
//   return bp;
// }

// /* ─────────────────────────────────────────────
//    BrandMarquee
// ───────────────────────────────────────────── */
// const BRANDS = [
//   'Louis Vuitton', 'Chanel', 'Gucci', 'Hermès', 'Prada', 'Dior',
//   'Balenciaga', 'Saint Laurent', 'Bottega Veneta', 'Celine',
//   'Fendi', 'Burberry', 'Valentino', 'Givenchy', 'Loewe', 'Bvlgari',
// ];

// export function BrandMarquee() {
//   const doubled = [...BRANDS, ...BRANDS];
//   return (
//     <section className="bg-[var(--dark)] py-[22px] overflow-hidden border-t border-white/[0.04]">
//       <div className="animate-marquee flex whitespace-nowrap">
//         {doubled.map((b, i) => (
//           <span key={i} className="inline-flex items-center gap-5 px-5">
//             <span className="font-display text-lg font-light text-white/[0.28] tracking-[0.18em] uppercase">
//               {b}
//             </span>
//             <span className="text-base" style={{ color: 'rgba(201,168,76,0.35)' }}>✦</span>
//           </span>
//         ))}
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    StatsBar — animated count-up
// ───────────────────────────────────────────── */
// function useCountUp(target, shouldStart, duration = 1800) {
//   const [count, setCount] = useState(0);
//   const rafRef = useRef(null);

//   useEffect(() => {
//     if (!shouldStart) return;
//     const startTime = performance.now();
//     const tick = (now) => {
//       const elapsed  = now - startTime;
//       const progress = Math.min(elapsed / duration, 1);
//       const eased    = 1 - Math.pow(1 - progress, 3);
//       setCount(Math.floor(eased * target));
//       if (progress < 1) {
//         rafRef.current = requestAnimationFrame(tick);
//       } else {
//         setCount(target);
//       }
//     };
//     rafRef.current = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(rafRef.current);
//   }, [shouldStart, target, duration]);

//   return count;
// }

// function AnimatedDelivery({ active }) {
//   const n = useCountUp(48, active, 1500);
//   return <>{n}hr</>;
// }

// function Stat({ value, label }) {
//   return (
//     <div className="text-center">
//       <div className="font-display text-[clamp(32px,8vw,56px)] font-light text-[var(--dark)] leading-none">
//         {value}
//       </div>
//       <div className="text-[9px] tracking-[0.22em] uppercase text-[var(--grey-mid)] font-semibold font-body mt-1.5">
//         {label}
//       </div>
//     </div>
//   );
// }

// export function StatsBar() {
//   const sectionRef        = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const el = sectionRef.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) { setVisible(true); observer.disconnect(); }
//       },
//       { threshold: 0.3 }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, []);

//   const pieces       = useCountUp(500, visible, 1600);
//   const authenticity = useCountUp(100, visible, 1400);
//   const houses       = useCountUp(12,  visible, 1200);

//   return (
//     <section
//       ref={sectionRef}
//       className="bg-[var(--cream)] border-t border-[#ede9e3] py-10 md:py-15 px-4 md:px-10"
//     >
//       <div className="max-w-[900px] mx-auto grid grid-cols-2">
//         {/* Left */}
//         <div className="flex flex-col items-center gap-6 md:gap-8 py-3 md:py-5">
//           <Stat value={`${pieces}+`} label="Pieces Curated" />
//           <Stat
//             value={visible ? <AnimatedDelivery active={visible} /> : '0hr'}
//             label="Average Delivery"
//           />
//         </div>
//         {/* Right */}
//         <div className="flex flex-col items-center gap-6 md:gap-8 py-3 md:py-5 border-l border-[#ede9e3]">
//           <Stat value={`${authenticity}%`} label="Authenticity Rate" />
//           <Stat value={`${houses}+`}       label="Global Houses" />
//         </div>
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    Testimonials
// ───────────────────────────────────────────── */
// export function Testimonials() {
//   const [reviews, setReviews] = useState([]);
//   const [idx, setIdx]         = useState(0);
//   const [paused, setPaused]   = useState(false);
//   const bp = useBreakpoint();

//   const isMobile     = bp === 'xs' || bp === 'sm';
//   const isTablet     = bp === 'md';
//   const visibleCount = isMobile ? 1 : isTablet ? 2 : 3;

//   useEffect(() => {
//     fetch(`${BASE_URL}/index.php?route=testimonials`)
//       .then(r => r.json())
//       .then(d => setReviews(Array.isArray(d) ? d : []))
//       .catch(() => {});
//   }, []);

//   useEffect(() => {
//     if (reviews.length <= visibleCount || paused) return;
//     const t = setInterval(() => setIdx(i => (i + 1) % reviews.length), 4500);
//     return () => clearInterval(t);
//   }, [reviews.length, paused, visibleCount]);

//   if (reviews.length === 0) return null;

//   const visible = Array.from({ length: visibleCount }, (_, offset) =>
//     reviews[(idx + offset) % reviews.length]
//   );

//   const gridCols = isMobile ? 'grid-cols-1' : isTablet ? 'grid-cols-2' : 'grid-cols-3';

//   return (
//     <section
//       className="bg-[var(--cream)] py-12 md:py-20 px-4 md:px-[50px]"
//       onMouseEnter={() => setPaused(true)}
//       onMouseLeave={() => setPaused(false)}
//     >
//       <div className="w-full">
//         {/* Header */}
//         <div className="text-center mb-8 md:mb-14">
//           <p className="text-[10px] tracking-[0.22em] uppercase text-[var(--gold)] font-semibold mb-4 font-body">
//             Client Stories
//           </p>
//           <h2 className="font-display text-[clamp(28px,5vw,48px)] font-light text-[var(--dark)] tracking-[-0.01em]">
//             What Our Clients Say
//           </h2>
//         </div>

//         {/* Cards */}
//         <div className={`grid ${gridCols} gap-3 md:gap-0.5`}>
//           {visible.map((r, i) => (
//             <div
//               key={`${r.id}-${i}`}
//               className="bg-white border border-[#ede9e3] flex flex-col gap-[18px] p-7 md:p-9 transition-opacity duration-500"
//             >
//               {/* Stars */}
//               <div className="flex gap-1">
//                 {Array.from({ length: Number(r.stars) || 5 }).map((_, si) => (
//                   <svg key={si} width={13} height={13} viewBox="0 0 24 24" fill="var(--gold)">
//                     <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//                   </svg>
//                 ))}
//               </div>

//               {/* Quote */}
//               <p className="text-base md:text-lg text-[var(--grey-dark)] leading-[1.85] italic font-display font-light flex-grow">
//                 "{r.text}"
//               </p>

//               {/* Reviewer */}
//               <div className="pt-4 border-t border-[#ede9e3]">
//                 <div className="text-[10px] tracking-[0.18em] uppercase text-[var(--dark)] font-semibold font-body">
//                   {r.name}{r.location ? ` — ${r.location}` : ''}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Dots */}
//         {reviews.length > visibleCount && (
//           <div className="flex justify-center gap-2 mt-8">
//             {reviews.map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setIdx(i)}
//                 className="h-2 rounded-[4px] border-none cursor-pointer p-0 transition-all duration-300"
//                 style={{
//                   width: i === idx ? 28 : 8,
//                   background: i === idx ? 'var(--gold)' : 'rgba(0,0,0,0.15)',
//                 }}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    RequestCTA
// ───────────────────────────────────────────── */
// export function RequestCTA({ onOpen }) {
//   const bp       = useBreakpoint();
//   const isMobile = bp === 'xs' || bp === 'sm';

//   return (
//     <section className="bg-[var(--dark)] py-[60px] md:py-20 px-4 md:px-6 text-center">
//       <div className="max-w-[560px] mx-auto flex flex-col items-center gap-[18px]">
//         <p className="text-[11px] tracking-[0.22em] uppercase text-[var(--gold)] font-medium font-body">
//           Sourcing Service
//         </p>
//         <h2 className="font-display text-[clamp(26px,5vw,46px)] font-light text-white tracking-[-0.01em] leading-[1.15]">
//           Can't Find Your Piece?
//         </h2>
//         <p className="text-[13px] text-white/50 font-light leading-[1.75] max-w-[360px] font-body">
//           Tell us the brand, model and colour. Our team sources globally and delivers to your door.
//         </p>
//         <button
//           onClick={onOpen}
//           className={`aurora-btn-gold mt-3.5 ${isMobile ? 'w-full' : 'w-auto'}`}
//         >
//           Request a Piece →
//         </button>
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    TrustBar
// ───────────────────────────────────────────── */
// const TRUST_ITEMS = [
//   {
//     label: 'Authenticity Guaranteed',
//     desc: 'Accompanied by original boutique bills.',
//     icon: (
//       <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
//         <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//         <polyline points="9,12 11,14 15,10" />
//       </svg>
//     ),
//   },
//   {
//     label: 'Globally Sourced',
//     desc: 'Directly from Paris, Milan & London.',
//     icon: (
//       <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
//         <circle cx="12" cy="12" r="10" />
//         <line x1="2" y1="12" x2="22" y2="12" />
//         <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
//       </svg>
//     ),
//   },
//   {
//     label: 'Bespoke Packaging',
//     desc: 'Arrives in signature designer boxes.',
//     icon: (
//       <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
//         <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//         <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
//         <line x1="12" y1="22.08" x2="12" y2="12" />
//       </svg>
//     ),
//   },
//   {
//     label: 'Best Value Assured',
//     desc: 'Expertly priced to reflect true luxury market value.',
//     icon: (
//       <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={1.3} viewBox="0 0 24 24">
//         <path d="M12 1v22" />
//         <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
//       </svg>
//     ),
//   },
// ];

// export function TrustBar() {
//   const bp       = useBreakpoint();
//   const isMobile = bp === 'xs' || bp === 'sm';

//   return (
//     <section className="bg-[var(--cream)] border-t border-b border-[#ede9e3] py-8 md:py-12 px-4 md:px-10">
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-2">
//         {TRUST_ITEMS.map(item => (
//           <div
//             key={item.label}
//             className={`flex flex-col gap-3.5 px-2.5 md:px-10 py-5 md:py-7 ${
//               isMobile ? 'items-center text-center' : 'items-start text-left'
//             }`}
//           >
//             <div className="text-[var(--dark)] opacity-55">{item.icon}</div>
//             <div className="text-[11px] md:text-[12px] tracking-[0.18em] uppercase font-medium text-[var(--dark)]">
//               {item.label}
//             </div>
//             <div className="text-[11px] text-[var(--grey-mid)] leading-[1.6] max-w-[220px]">
//               {item.desc}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    FeaturedBrands
// ───────────────────────────────────────────── */
// export function FeaturedBrands() {
//   const bp       = useBreakpoint();
//   const isMobile = bp === 'xs' || bp === 'sm';
//   const brands   = ['Louis Vuitton', 'Chanel', 'Gucci', 'Hermès', 'Prada', 'Dior'];

//   return (
//     <section className="py-12 md:py-[72px] px-4 md:px-10 bg-white">
//       <div className="max-w-[1200px] mx-auto">
//         <div className="text-center mb-8 md:mb-12">
//           <p className="text-[11px] tracking-[0.22em] uppercase text-[var(--gold)] font-medium mb-3.5 font-body">
//             Curated Selection
//           </p>
//           <h2 className="font-display text-[clamp(26px,4vw,44px)] font-light text-[var(--dark)] tracking-[-0.01em]">
//             Shop by Designer
//           </h2>
//         </div>
//         <div className="grid grid-cols-2 md:grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4">
//           {brands.map(b => (
//             <Link
//               key={b}
//               to={`/shop?brand=${encodeURIComponent(b)}`}
//               className="block p-7 border border-[var(--grey)] text-center no-underline transition-all duration-200 hover:border-[var(--gold)] hover:shadow-md"
//             >
//               <span className={`font-display font-light text-[var(--dark)] tracking-[0.05em] ${isMobile ? 'text-[15px]' : 'text-[18px]'}`}>
//                 {b}
//               </span>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }